import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import TitlePage from '../../components/general/TitlePage/TitlePage';
import ArticleCard from '../../components/extern/ArticleCard/ArticleCard';
import CategoryFilter from './../../components/CategoryFilter/CategoryFilter';

import ArticleData from '../../utils/dataArticle';
import { gsap } from 'gsap';

const getUniqueCategories = (articles) => {
  const categories = articles.map(article => article.category || 'Others');
  return [...new Set(categories)];
};

const SpecsPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const containerRef = useRef();

  const filteredArticles = ArticleData.filter(article =>
    selectedCategory === 'All' || article.category === selectedCategory
  );

  useEffect(() => {
    const cards = containerRef.current?.querySelectorAll('.article-card');
    if (cards) {
      gsap.fromTo(cards, { y: 20, opacity: 0 }, {
        y: 0,
        opacity: 1,
        stagger: 0.1,
        duration: 0.4,
        ease: 'power2.out'
      });
    }
  }, [selectedCategory]);

  const categories = getUniqueCategories(ArticleData);

  return (
    <main className="container">
      <TitlePage
        title="Content"
        subtitle="Articles, guides, and insights for your daily routine and strategic decisions."
      />

      <Helmet>
        <title>Content</title>
      </Helmet>

      <div className="filter-section">
        <CategoryFilter
          label="Category:"
          options={categories.filter(c => c !== 'All')}
          selected={selectedCategory}
          onChange={setSelectedCategory}
          defaultOption={{ label: 'All', value: 'All' }}
        />
      </div>

      <div className="article-grid" ref={containerRef}>
        {filteredArticles.length > 0 ? (
          filteredArticles.map((a, i) => (
            <ArticleCard
              key={i}
              title={a.title}
              url={a.url}
              isDisabled={!a.url}
              category={a.category}
            />
          ))
        ) : (
          <ArticleCard title="No articles available" isDisabled />
        )}
      </div>
    </main>
  );
};

export default SpecsPage;
